import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VantGreen from 'vant-green';
import 'vant-green/lib/index.css';
Vue.use(VantGreen);
Vue.use(ElementUI);
Vue.config.productionTip = false;
// Vue.prototype.$globalVar = 'http://47.105.130.252/PhotoPath/images'; // 全局通用变量
// Vue.prototype.$globalVar = 'http://39.105.48.72/PHOTOSPATH/images'; // 全局通用变量

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');